import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';

class Header extends Component {
    render() {
        return (
            <div className="header">
               带教绩效排行
                <span className="return-back" 
                    onClick={() =>  this.props.history.push({pathname: `/home`, state: {key: 'performanceRank'}})}
                >
                    <i
                        className="icon iconfont"
                        style={{ marginRight: 4, fontSize: '20px' }}
                    >&#xe63d;</i>
                    返回
                </span>
            </div>
        )
    }
}

export default withRouter(Header);


// WEBPACK FOOTER //
// ./src/components/home/TeachingRank/components/Header.js